export let OfferProps  = {
    offerType: {
        // accept `number` and `percent`
        default: 'number',
    },
    offerStatus: {
        type: Boolean,
        default: true,
    }
}